<template>
  <div class="detail-data-wrapper mb-4 mt-4">
    <div class="flex detail-container md:flex-row md:items-start w-full gap-4">
      <div class="detail-data" style="flex:0.7">
        <!-- No Anggota -->
        <b-row class="mb-2">
          <b-col cols="4" class="detail-data-label">No. Anggota</b-col>
          <b-col>
            <strong>{{ anggota.no }}</strong>

            <span
              v-if="anggota.statusPembayaran === 1"
              class="badge badge-success ml-2 text-sm"
            >
              Lancar
            </span>

            <b-button
              v-if="anggota.no && anggota.no !== '-'"
              variant="pgiBtn"
              size="sm"
              class="ml-2"
              @click="$emit('refresh', anggota.no)"
            >
              Refresh Anggota
            </b-button>
          </b-col>
        </b-row>

        <!-- Identitas -->
        <div v-for="(item, i) in anggota.identitas" :key="i">
          <b-row class="mb-1">
            <b-col cols="4" class="detail-data-label">
              {{ i === 0 ? 'Jenis Identitas' : '' }}
            </b-col>
            <b-col cols="8">
              {{ i + 1 }}). {{ item.jenisIdentitas }} - {{ item.noIdentitas }}
              <a
                @click="$emit('preview-foto', item.fotoIdentitas)"
                style="cursor:pointer;font-weight:bold;color:#1e73be"
              >
                (Lihat Foto)
              </a>
            </b-col>
          </b-row>
        </div>

        <!-- Nama -->
        <b-row class="mb-2">
          <b-col cols="4" class="detail-data-label">Nama</b-col>
          <b-col>
            <div class="wrapper-whatsapp-detail">
              <span>{{ anggota.nama }}</span>

              <FieldApproval
                v-if="canEdit && anggota.nama && anggota.nama !== '-'"
                label="Nama Anggota"
                field-key="name"
                :current-value="anggota.nama"
                :selected-row="anggota"
                :loading="false"
                @submit="$emit('edit-anggota', $event)"
              />
            </div>
          </b-col>
        </b-row>

        <!-- No HP -->
        <b-row class="mb-2">
          <b-col cols="4" class="detail-data-label">No. HP</b-col>
          <b-col>
            <div class="wrapper-whatsapp-detail">
              <span>{{ anggota.noHp }}</span>

              <template v-if="anggota.noHp && anggota.noHp !== '-'">
                <FieldApproval
                  v-if="canEdit"
                  label="No Handphone"
                  field-key="no-handphone"
                  :current-value="anggota.noHp"
                  :selected-row="anggota"
                  :loading="false"
                  :showUpload="true"
                  @submit="$emit('edit-anggota', $event)"
                />

                <b-button
                  size="sm"
                  variant="pgiBtn"
                  @click="$emit('wa', anggota.noHp)"
                >
                  Hubungi WA
                </b-button>

                <b-button
                  size="sm"
                  variant="pgiBtn"
                  @click="$emit('copy-wa', anggota.noHp)"
                >
                  <i class="fa fa-copy mr-1"></i>
                  Salin Link WA
                </b-button>
              </template>
            </div>
          </b-col>
        </b-row>

        <!-- Alamat -->
        <b-row class="mb-2">
          <b-col cols="4" class="detail-data-label">Alamat</b-col>
          <b-col>{{ anggota.alamat }}</b-col>
        </b-row>
      </div>
    </div>

    <!-- Action Button -->
    <div class="anggota-action-btn mt-2" v-if="anggota.no !== '-'">
      <b-button v-if="editAnggota" variant="pgiBtn" @click="$emit('edit')">
        <i class="fa fa-pencil mr-2"></i>
        Edit Anggota
      </b-button>

      <b-button variant="pgiBtn" @click="$emit('detail')">
        <i class="fa fa-info mr-2"></i>
        Detail Anggota
      </b-button>

      <b-button
        variant="pgiBtn"
        v-if="$companyId === 'PGI'"
        @click="$emit('reset-password')"
      >
        <i class="fa fa-key mr-2"></i>
        Reset Password
      </b-button>

      <b-button variant="pgiBtn" @click="$emit('edit-identitas')">
        <i class="fa fa-edit mr-2"></i>
        Edit Identitas
      </b-button>
    </div>
  </div>
</template>

<script>
import FieldApproval from '@/components/common/FieldApproval'

export default {
  name: 'DetailSelectAnggota',
  components: {
    FieldApproval,
  },
  props: {
    anggota: { type: Object, required: true },
    canEdit: { type: Boolean, default: false },
    editAnggota: { type: Boolean, default: false },
  }
}
</script>
